export class CircleElementStyleFormatHelper {
    static _targetTexts = {
        "terminalstoppoint": "Paragem Terminal",
        "stoppoint": "Paragem",
        "currentstoppoint": "Paragem Alvo",
        "hiddenstoppoint": "Paragem Escondida"
    }

    static getTargetTextsArray(targetsArray) {
        const output = [];
        
        for(const idx in targetsArray) {
            output.push(this._targetTexts[targetsArray[idx].toLowerCase()]);
        }

        return output;
    }

    static getTargetText(target) {
        return this._targetTexts[target.toLowerCase()];
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/helpers/CircleElementStyleFormatHelper.js